import { Box } from '@mui/material';
import DialogBody from 'components/dialog/DialogBody';
import DialogButtons from 'components/dialog/DialogButtons';
import DialogContent from 'components/dialog/DialogContent';
import DialogTitle from 'components/dialog/DialogTitle';
import { memo, ReactNode } from 'react';

interface IInfoDialogProps {
  contents: string;
  title?: string;
  buttonInfo: ReactNode;
}
function InfoDialog({ title = '', contents, buttonInfo }: IInfoDialogProps): JSX.Element {
  return (
    <DialogContent width={{ desktop: 400 }} height={{ desktop: 'fit-content' }}>
      {title && <DialogTitle hideCloseButton>{title}</DialogTitle>}
      <DialogBody style={{ overflowX: 'hidden', overflowY: 'scroll !important' }}>
        <Box sx={{ fontSize: 18, fontWeight: 700, mb: 3 }}>{contents}</Box>
      </DialogBody>
      <DialogButtons justifyContent="flex-end" marginTop="8px">
        {buttonInfo}
      </DialogButtons>
    </DialogContent>
  );
}

export default memo(InfoDialog);
